<template>
  <div :class="$style['sample-table-form']">
    <el-button type="primary" class="edit-confirm-button" @click="editConfirm" v-if="Value.length">{{ disabled?'编辑':'确认'}}</el-button>
    <el-table :data="Value" stripe style="width: 100%">
      <el-table-column prop="date" label="样品编号" width="200">
        <template slot-scope="scope">
          <el-input placeholder="样品编号" v-model="scope.row.orderCode" :disabled="disabled">
          </el-input>
        </template>
      </el-table-column>
      <el-table-column prop="date" label="样品名称" width="110">
        <template slot-scope="scope">
          <el-input placeholder="样品名称" v-model="scope.row.orderName" :disabled="disabled">
          </el-input>
        </template>
      </el-table-column>
      <el-table-column prop="date" label="客户编号" width="110">
        <template slot-scope="scope">
          <el-input placeholder="客户编号" v-model="scope.row.customerCode" :disabled="disabled">
          </el-input>
        </template>
      </el-table-column>
      <el-table-column prop="date" label="检测项目" width="120">
        <template slot-scope="scope">
          <template v-if="disabled || scope.row.disabledEditProduct">
            <template v-if="scope.row.labExamItems&&scope.row.labExamItems.length">
              <div v-for="(item,index) in scope.row.labExamItems" :key="index">
                {{item.itemName}}
              </div>
            </template>
          </template>
          <lab-product-selector v-else :disabled="disabled" v-model="scope.row.labExamItemId" @productChenge="productChenge(scope.row)" :labExamItemList="labExamItemList" :hasExamList="hasExamList"></lab-product-selector>
        </template>
      </el-table-column>
      <el-table-column prop="date" label="检测依据" width="120">
        <template slot-scope="scope">
          <template v-if="disabled || scope.row.disabledEditProduct">
            <template v-if="scope.row.labExamItems&&scope.row.labExamItems.length">
              <div v-for="(item,index) in scope.row.labExamItems" :key="index">
                {{item.examBasis&&item.examBasis.name}}
              </div>
            </template>
          </template>
          <el-input v-else placeholder="检测依据" v-model="scope.row.examBasisName" :disabled="disabled" :readonly="hasExamList">
          </el-input>
        </template>
      </el-table-column>
      <el-table-column prop="date" label="生产单位" width="120">
        <template slot-scope="scope">
          <el-input placeholder="生产单位" v-model="scope.row.productionUnit" :disabled="disabled">
          </el-input>
        </template>
      </el-table-column>
      <el-table-column prop="date" label="生产日期" width="165">
        <template slot-scope="scope">
          <el-input placeholder="生产日期" v-model="scope.row.orderProductDate" :disabled="disabled">
          </el-input>
          <!-- <el-date-picker v-model="scope.row.orderProductDate" type="date" placeholder="选择日期" :disabled="scope.row.disabled"></el-date-picker> -->
        </template>
      </el-table-column>
      <el-table-column prop="date" label="生产批号" width="120">
        <template slot-scope="scope">
          <el-input placeholder="生产批号" v-model="scope.row.productBatchCode" :disabled="disabled">
          </el-input>
        </template>
      </el-table-column>
      <el-table-column prop="date" label="商标" width="120">
        <template slot-scope="scope">
          <el-input placeholder="商标" v-model="scope.row.brand" :disabled="disabled">
          </el-input>
        </template>
      </el-table-column>
      <el-table-column prop="date" label="规格/型号" width="140">
        <template slot-scope="scope">
          <wt-selector v-model="scope.row.specificationModel" allowCreate filterable :disabled="disabled" :options="models" placeholder="规格/型号"></wt-selector>
        </template>
      </el-table-column>
      <el-table-column
        prop="date"
        label="数量"
        width="100">
        <template slot-scope="scope">
          <el-input
            placeholder="数量"
            v-model="scope.row.orderCount"
            :disabled="disabled">
          </el-input>
        </template>
      </el-table-column>
      <el-table-column
          prop="date"
          label="计量单位"
          width="100">
          <template slot-scope="scope">
            <wt-selector v-model="scope.row.orderCountUnit" allowCreate filterable :disabled="disabled" :options="units" placeholder="计量单位"></wt-selector>
          </template>
        </el-table-column>


      <el-table-column prop="date" label="颜色" width="100">
        <template slot-scope="scope">
          <wt-selector v-model="scope.row.color" allowCreate filterable :disabled="disabled" :options="colors" placeholder="颜色"></wt-selector>
        </template>
      </el-table-column>
      <el-table-column prop="date" label="形态" width="100">
        <template slot-scope="scope">
          <wt-selector v-model="scope.row.shapes" allowCreate filterable multiple :disabled="disabled" :options="shapes" placeholder="形态"></wt-selector>
        </template>
      </el-table-column>
      <el-table-column prop="date" label="包装" width="110">
        <template slot-scope="scope">
          <wt-selector v-model="scope.row.pack" allowCreate filterable :disabled="disabled" :options="packs" placeholder="包装" ></wt-selector>
        </template>
      </el-table-column>
      <el-table-column prop="date" label="存放条件" width="110">
        <template slot-scope="scope">
          <wt-selector v-model="scope.row.storage_show" allowCreate filterable :disabled="disabled" :options="storages" placeholder="存放条件" multiple></wt-selector>
        </template>
      </el-table-column>
      <el-table-column width="80">
        <template slot-scope="scope">
            <el-button type="text" v-if="!disabled" @click="copyOrder(scope.row)">复制</el-button>
            <i v-if="!recollect" class="el-icon-circle-close" @click="deleteItem(scope.$index)"></i>
          <!-- <i v-if="scope.row.disabled" class="el-icon-edit-outline" @click="editItem(scope.$index)"></i>

          <i v-else class="el-icon-circle-check" @click="saveItem(scope.$index)"></i> -->

        </template>
      </el-table-column>
    </el-table>

    <el-button v-if="!recollect" type="text" :class="$style['add-btn']" @click="addItem">添加一条样品</el-button>
  </div>
</template>
<script>
import labProductSelector from 'cps/selector/lab-product-selector'
import {
  colors,
  storages,
  shapes,
  models,
  packs,
  units
} from 'json/trust-deed'
import {prefixZero} from "@/utils/formUtils.js"
const requiredColumn = ['orderName', 'labExamItemId', 'examBasisName', 'storage']

export default {
  name: 'sample-table-form',
  props: {
    value: {
      type: Array,
      default: () => []
    },
    recollect: {
      type: Boolean,
      default: false
    },
    labExamItemList: Array,
    hasExamList: Boolean,
    isEdit: Boolean,
    sampleDisabled: Boolean,
    billCode: String
  },
  components: {
    labProductSelector
  },
  data () {
    return {
      colors,
      storages,
      shapes,
      models,
      packs,
      units,
      Value: this.value,
      disabled: this.sampleDisabled,
    }
  },
  watch: {
    value (val) {
			if(val&&val.length){
        val.forEach(item => {
          if (item.labExamItems) {
            item.labExamItemId = item.labExamItems.map(etem => etem.id)
            item.examBasisName = item.labExamItems.map(etem => etem.examBasis && etem.examBasis.name)
          }
					// item.pack_show=item.pack.split()
					// this.$set(item,'pack_show',item.pack.split(','))
          if (item.storage) {
            this.$set(item, 'storage_show', item.storage && item.storage.split(','))
          }
				})
				val.map(item=>item)
			}
      this.Value = val
    },
    Value (val) {
    }
  },
  methods: {
    editConfirm () {
      if (this.disabled) {
        this.disabled = !this.disabled
      } else {
        let i=0
        this.Value.forEach(item => {
          item.storage = item.storage_show?.join()
          this.formValidateItem(item).then(() => {
            i++
            // this.Value[index].pack=this.Value[index].pack_show.join()
              // 重新生成 shape_text，避免“编辑->确认->编辑->确认”导致重复追加
              const shapesArr = Array.isArray(item.shapes)
                ? item.shapes
                : (item.shapes ? [item.shapes] : [])
              // 历史数据/初始化阶段可能只有 shape，shapes 可能为空，因此做兜底
              item.shape_text = shapesArr.length
                ? shapesArr.join('')
                : (item.shape_text || item.shape || '')
              item.shape = item.shape_text
            if (i === this.Value.length) {
              this.disabled = true
              this.$emit('input', this.Value)
            }
            // this.saveValue.push(this.Value[index])
          }).catch((err) => {
            this.$message.warning(err.message)
            return
          })
        })
      }
    },
    productChenge (row) {
      row.labExamItems = []
      if (row.labExamItemId && _.isArray(row.labExamItemId)) {
        row.labExamItemId.forEach(item => {
          this.labExamItemList.forEach(etem => {
            if (item === etem.id) {
              this.$set(row, 'examBasisName', row.examBasis ? row.examBasis + '/' + etem.examBasis.name : etem.examBasis.name)
              // row.examBasis = row.examBasis ? row.examBasis + '/' + etem.examBasis.name : etem.examBasis.name
              // this.$set(row,'labExamItems')
              row.labExamItems.push(etem)
            }
          })
        })
      }
      // this.$set(row, 'labExamItems' )
    },
    formValidate () {
      return Promise.all(this.Value.map(e => this.formValidateItem(e)))
    },
    formValidateItem (obj,isCopy) {
      const hasNull = !Object.keys(obj).length || !requiredColumn.every(key =>{
				return Object.keys(obj).includes(key) && (typeof obj[key] === 'string' ? obj[key] : obj[key]?.length)
				})
      if (hasNull) {
        let text=isCopy?'请填写完整样品信息再复制！':'请填写完整样品信息！'
        return Promise.reject(new Error(text))
      } else {
        return Promise.resolve()
      }
    },
    addItem () {
      this.disabled = false
      if (!this.Value?.length) {
        this.Value.push({ disabled: false })
        return
			}
      let newCode
      let index = this.Value.length - 1
			if(this.Value[index].orderCode){
				newCode=this.getAddSampleCode()
      }
      this.Value[index].storage = this.Value[index].storage_show?this.Value[index].storage_show.join(): this.Value[index].storage
      this.formValidateItem(this.Value[index]).then(() => {
        this.Value.push({ disabled: false,orderCode:newCode })
      }).catch(err => {
        this.$message.error(err.message)
      })
		},
		//处理新增的样本编号
		getAddSampleCode(){
			let lastOrderCode=this.Value[this.Value.length - 1].orderCode//委托单中最后一个样本的样本编号
			let lastIndex=lastOrderCode.lastIndexOf('-')
				//如果样本编号里面含有’-‘那么取出样本编号中的最后一个’-‘后面的数据，作为新的样本编号的基数。如果没有’-‘且是数字就取出全部内容，否则将不取（不用计算或给新的样本行赋值）
			let lastCode=lastOrderCode.indexOf('-')>-1?lastOrderCode.substring(lastIndex+1,lastOrderCode.length):(isNaN(lastOrderCode)?'':lastOrderCode)
			let newCode=lastCode&&isNaN(Number(lastCode))?'':Number(lastCode)+1
			newCode=newCode&&prefixZero(newCode,2)
			let beforeCode=lastOrderCode.indexOf('-')>-1?lastOrderCode.substring(0,lastIndex+1):''
			let code=beforeCode+newCode
			return code
		},
    deleteItem (index) {
      // if (index === 0 && this.Value.length === 1) {
      //   this.$message.error('不能再删除了')
      //   return
      // }
      this.$confirm('确定要删除该条数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
        // type: 'warning'
      }).then(() => {
        this.Value.splice(index, 1)
      })
    },
    editItem (index) {
      this.Value[index].disabled = false
    },

    saveItem (index) {
				this.Value[index].storage=this.Value[index].storage_show.join()
      this.formValidateItem(this.Value[index]).then(() => {
				// this.Value[index].pack=this.Value[index].pack_show.join()
        this.Value[index].disabled = true
        this.disabled=true
        // this.saveValue.push(this.Value[index])
      }).catch((err) => {
        this.$message.warning(err.message)
      })
    },
    copyOrder (row) {
      let newOrderNumber
      if (this.billCode&& row.orderCode&&row.orderCode.indexOf(this.billCode) > -1) {
        let orderNumbers = this.Value.map(e => {
          return e.orderCode.split('-').pop()
        })
        let max = Math.max(...orderNumbers)
        newOrderNumber=max>=9?max+1:`0${max+1}`
      }
      this.formValidateItem(row, true).then(() => {
        this.Value.push({ ...row, summaryId: null, sortIds: null, orderCode: newOrderNumber ? `${this.billCode}-${newOrderNumber}` : row.orderCode })
      }).catch(err => {
        this.$message.warning(err.message)
      })
    }
  }
}
</script>
<style module lang="less">
@import '~less/var.less';
  .sample-table-form {
    padding: 10px 20px;
    :global{
      .edit-confirm-button{
        width: 80px;
      }
      .el-table{
        .cell{
          display: flex;
          align-items: center;
        }
      }
    }
    .el-input,
    .el-input__inner {
      height: .4rem !important;
    }
    .add-btn{
      margin:10px 0 10px 20px;
    }
    :global{
      .el-select,
      .el-date-editor,
      .el-input__inner{
        min-width: 100% !important;
        width: 100% !important;
      }

      .el-icon-circle-close,
      .el-icon-circle-check{
        font-size: 20px;
        cursor: pointer;
      }
      .el-icon-circle-close{
        color: red;
      }
      .el-button{
        margin-right:15px;
      }
      .el-icon-circle-check{
        color:@mainColor;
      }
      .el-icon-edit-outline{
        font-size: 19px;
        color:@mainColor;
      }
    }
  }
</style>
